<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Dashboard Thống kê</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Thống kê công việc</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card filter-card">
        <div
          class="card-header filter-card-header"
          data-toggle="collapse"
          href="#filter_inputs"
          role="button"
          aria-expanded="true"
          aria-controls="filter_inputs"
        >
          <h5 class="card-title mb-0">Bộ lọc dữ liệu</h5>
          <i class="fa fa-chevron-down collapse-icon"></i>
        </div>
        <div class="card-body collapse" id="filter_inputs">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Không gian làm việc</label>
                <select class="form-control" v-model="filters.workspaceId">
                  <option :value="null">Tất cả</option>
                  <option v-for="ws in workspaces" :key="ws.id" :value="ws.id">
                    {{ ws.tieuDe }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Cột công việc</label>
                <select
                  class="form-control"
                  v-model="filters.columnId"
                  :disabled="!filters.workspaceId"
                >
                  <option :value="null">Tất cả cột</option>
                  <option v-for="col in columns" :key="col.id" :value="col.id">
                    {{ col.tenCot }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Phòng ban</label>
                <vue-multiselect
                  v-model="selectedPhongBan"
                  :options="phongBanOptions"
                  placeholder="Tất cả phòng ban"
                  label="tenPhongBan"
                  track-by="idPhongBan"
                  :allow-empty="true"
                  :multiple="false"
                  deselect-label="Nhấn Enter để bỏ chọn"
                  select-label="Nhấn Enter để chọn"
                  selected-label="Đã chọn"
                ></vue-multiselect>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Người dùng</label>
                <vue-multiselect
                  v-model="selectedUser"
                  :options="users"
                  placeholder="Tất cả người dùng"
                  label="hoTen"
                  track-by="idNguoiDung"
                  :allow-empty="true"
                  deselect-label="Nhấn Enter để bỏ chọn"
                  select-label="Nhấn Enter để chọn"
                  selected-label="Đã chọn"
                ></vue-multiselect>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Trạng thái công việc</label>
                <select
                  class="form-control"
                  v-model="filters.trangThaiCongViec"
                >
                  <option :value="null">Tất cả</option>
                  <option value="TODO">Cần làm</option>
                  <option value="IN_PROGRESS">Đang làm</option>
                  <option value="DONE">Hoàn thành</option>
                  <option value="ARCHIVED">Đã lưu trữ</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Độ ưu tiên</label>
                <select class="form-control" v-model="filters.doUuTien">
                  <option :value="null">Tất cả</option>
                  <option value="URGENT">Khẩn cấp</option>
                  <option value="HIGH">Cao</option>
                  <option value="MEDIUM">Trung bình</option>
                  <option value="LOW">Thấp</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Thời hạn</label>
                <select class="form-control" v-model="filters.isOverdue">
                  <option :value="null">Tất cả</option>
                  <option value="false">Còn hạn</option>
                  <option value="true">Hết hạn</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Độ khó</label>
                <select class="form-control" v-model="filters.doKho">
                  <option :value="null">Tất cả</option>
                  <option value="EASY">Dễ</option>
                  <option value="MEDIUM">Vừa</option>
                  <option value="HARD">Khó</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4">
              <div class="form-group">
                <label>Khoảng thời gian</label>
                <div class="btn-group w-100">
                  <button
                    class="btn btn-outline-secondary"
                    :class="{ active: timePreset === 'ngay' }"
                    @click="setTimePreset('ngay')"
                  >
                    Ngày
                  </button>
                  <button
                    class="btn btn-outline-secondary"
                    :class="{ active: timePreset === 'tuan' }"
                    @click="setTimePreset('tuan')"
                  >
                    Tuần
                  </button>
                  <button
                    class="btn btn-outline-secondary"
                    :class="{ active: timePreset === 'thang' }"
                    @click="setTimePreset('thang')"
                  >
                    Tháng
                  </button>
                  <button
                    class="btn btn-outline-secondary"
                    :class="{ active: timePreset === 'nam' }"
                    @click="setTimePreset('nam')"
                  >
                    Năm
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label>Tùy chỉnh ngày</label>
              <div class="d-flex align-items-center">
                <input
                  type="date"
                  class="form-control mr-2"
                  v-model="customStartDate"
                  placeholder="Từ ngày"
                />
                <span>-</span>
                <input
                  type="date"
                  class="form-control ml-2"
                  v-model="customEndDate"
                  placeholder="Đến ngày"
                />
              </div>
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <div class="form-group w-100">
                <div class="d-flex" style="gap: 10px">
                  <button
                    class="btn btn-secondary w-100"
                    @click="resetFilters"
                    :disabled="loading"
                  >
                    <i class="fa fa-refresh"></i> Làm mới
                  </button>
                  <button
                    class="btn btn-primary w-100"
                    @click="executeFilters"
                    :disabled="loading"
                  >
                    <i class="fa fa-filter"></i> Lọc
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="text-center py-5">
        <div
          class="spinner-border text-primary"
          role="status"
          style="width: 3rem; height: 3rem"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-else>
        <div class="row" v-if="dashboardData">
          <div
            class="col-lg-3 col-sm-6"
            v-for="kpi in kpiCards"
            :key="kpi.label"
          >
            <div class="card dash-widget" :class="kpi.cardClass">
              <div class="card-body">
                <span class="dash-widget-icon" :class="kpi.iconColor"
                  ><i :class="kpi.icon"></i
                ></span>
                <div class="dash-widget-info">
                  <h3>{{ kpi.value }}</h3>
                  <span>{{ kpi.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="dashboardData">
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">Phân bổ công việc theo trạng thái</h3>
                <div id="chart-trang-thai"></div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">Tỷ lệ công việc theo độ ưu tiên</h3>
                <div id="chart-do-uu-tien"></div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">Tỷ lệ theo độ khó</h3>
                <div id="chart-do-kho"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="dashboardData">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">Xu hướng hoàn thành công việc</h3>
                <div id="chart-xu-huong"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">
                  Phân bổ công việc theo Không gian làm việc (Trừ phần lưu trữ)
                </h3>
                <div id="chart-stacked-workspace"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="dashboardData && dashboardData.hieuSuatNhanVien">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">Hiệu suất nhân viên</h3>
                <div class="table-responsive">
                  <table class="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Nhân viên</th>
                        <th class="text-center">Task được giao</th>
                        <th class="text-center">Task hoàn thành</th>
                        <th class="text-center">Task quá hạn</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in dashboardData.hieuSuatNhanVien"
                        :key="item.nguoiDung.idNguoiDung"
                      >
                        <td>
                          <h2 class="table-avatar">
                            <a href="#" class="avatar"
                              ><img
                                :alt="item.nguoiDung.hoTen"
                                :src="
                                  item.nguoiDung.avatarUrl ||
                                  '/assets/img/profiles/avatar-02.jpg'
                                "
                            /></a>
                            <a href="#"
                              >{{ item.nguoiDung.hoTen }}
                              <span>{{ item.nguoiDung.email }}</span></a
                            >
                          </h2>
                        </td>
                        <td class="text-center">{{ item.soTaskDuocGiao }}</td>
                        <td class="text-center">{{ item.soTaskHoanThanh }}</td>
                        <td class="text-center text-danger font-weight-bold">
                          {{ item.soTaskQuaHan }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          !dashboardData.hieuSuatNhanVien ||
                          dashboardData.hieuSuatNhanVien.length === 0
                        "
                      >
                        <td colspan="4" class="text-center text-muted">
                          Không có dữ liệu.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" ref="listTaskRef">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  Danh sách công việc chi tiết ({{ pagination.totalElements }}
                  công việc)
                </h3>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-hover table-striped mb-0">
                    <thead>
                      <tr>
                        <th style="width: 30%">Tên công việc</th>
                        <th>Người thực hiện</th>
                        <th>Ngày bắt đầu</th>
                        <th>Ngày hết hạn</th>
                        <th>Ngày hoàn thành</th>
                        <th>Độ ưu tiên</th>
                        <th>Độ khó</th>
                        <th>Thẻ Tag</th>
                        <th>Trạng thái</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="task in detailedTasks" :key="task.id">
                        <router-link
                          v-if="task.trangThaiCongViec != 'ARCHIVED'"
                          :to="`/bang-phan-chia-cong-viec/${task.workspaceId}?openTask=${task.id}`"
                        >
                          <td>
                            <div
                              class="task-title-col"
                              v-tooltip.top="task.tieuDe"
                            >
                              {{ task.tieuDe }}
                            </div>
                            <small class="text-muted"
                              >{{ task.workspaceName }} /
                              {{ task.columnName }}</small
                            >
                          </td>
                        </router-link>
                        <td v-else>
                          <div
                            class="task-title-col"
                            v-tooltip.top="task.tieuDe"
                          >
                            {{ task.tieuDe }}
                          </div>
                          <small class="text-muted"
                            >{{ task.workspaceName }} /
                            {{ task.columnName }}</small
                          >
                        </td>
                        <td>
                          <div
                            class="d-flex align-items-center"
                            v-if="
                              task.assignedUsers &&
                              task.assignedUsers.length > 0
                            "
                          >
                            <img
                              v-for="user in task.assignedUsers.slice(0, 3)"
                              :key="user.idNguoiDung"
                              :src="
                                user.avatarUrl ||
                                '/assets/img/profiles/avatar-02.jpg'
                              "
                              class="rounded-circle mr-1"
                              width="24"
                              height="24"
                              v-tooltip="user.hoTen"
                            />
                            <span
                              v-if="task.assignedUsers.length > 3"
                              class="badge badge-light ml-1"
                              >+{{ task.assignedUsers.length - 3 }}</span
                            >
                          </div>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td>
                          <span
                            :class="
                              (task.ngayBatDau && task.ngayKetThuc) ??
                              'text-info'
                            "
                          >
                            {{
                              task.ngayBatDau
                                ? new Date(task.ngayBatDau).toLocaleString(
                                    "vi-VN"
                                  )
                                : "Không giới hạn"
                            }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="{
                              'text-danger': isOverdue(
                                task.ngayKetThuc,
                                task.trangThaiCongViec
                              ),
                              'text-info':
                                !task.ngayKetThuc && !task.ngayBatDau,
                            }"
                            v-tooltip="
                              isOverdue(
                                task.ngayKetThuc,
                                task.trangThaiCongViec
                              )
                                ? 'Trễ hạn'
                                : null
                            "
                          >
                            {{
                              task.ngayKetThuc
                                ? new Date(task.ngayKetThuc).toLocaleString(
                                    "vi-VN"
                                  )
                                : "Không giới hạn"
                            }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="{
                              'text-danger': isCompletedLate(
                                task.ngayHoanThanh,
                                task.ngayKetThuc
                              ),
                            }"
                            v-tooltip="
                              isCompletedLate(
                                task.ngayHoanThanh,
                                task.ngayKetThuc
                              )
                                ? 'Hoàn thành trễ hạn'
                                : null
                            "
                          >
                            {{
                              task.ngayHoanThanh
                                ? new Date(task.ngayHoanThanh).toLocaleString(
                                    "vi-VN"
                                  )
                                : "-"
                            }}
                          </span>
                        </td>
                        <td>
                          <span
                            class="badge"
                            :class="getPriorityBadgeClass(task.doUuTien)"
                            >{{
                              priorityMap[task.doUuTien] || task.doUuTien
                            }}</span
                          >
                        </td>
                        <td>
                          <span
                            v-if="task.doKho"
                            class="badge"
                            :class="{
                              'badge-success': task.doKho === 'EASY',
                              'badge-warning': task.doKho === 'MEDIUM',
                              'badge-danger': task.doKho === 'HARD',
                            }"
                          >
                            {{
                              task.doKho === "EASY"
                                ? "Dễ"
                                : task.doKho === "MEDIUM"
                                ? "Vừa"
                                : "Khó"
                            }}
                          </span>
                          <span v-else class="text-muted">-</span>
                        </td>

                        <td>
                          <div
                            v-if="
                              task.tags &&
                              typeof task.tags === 'string' &&
                              task.tags.length > 0
                            "
                          >
                            <span
                              v-for="(tag, index) in task.tags
                                .split(',')
                                .slice(0, 3)"
                              :key="index"
                              class="badge badge-light border mr-1"
                              style="font-weight: normal"
                            >
                              #{{ tag.trim() }}
                            </span>

                            <span
                              v-if="task.tags.split(',').length > 3"
                              class="badge badge-secondary"
                              style="font-weight: normal; cursor: help"
                              v-tooltip="
                                'Các thẻ khác: ' +
                                task.tags.split(',').slice(3).join(', ')
                              "
                            >
                              +{{ task.tags.split(",").length - 3 }}
                            </span>
                          </div>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td>
                          <span
                            class="badge"
                            :class="getStatusBadgeClass(task.trangThaiCongViec)"
                            >{{
                              statusMap[task.trangThaiCongViec] ||
                              task.trangThaiCongViec
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr v-if="detailedTasks.length === 0">
                        <td colspan="5" class="text-center text-muted py-3">
                          Không có công việc nào khớp với bộ lọc.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="card-footer d-flex justify-content-end"
                v-if="pagination.totalPages > 1"
              >
                <nav>
                  <ul class="pagination mb-0">
                    <li
                      class="page-item"
                      :class="{ disabled: pagination.currentPage === 0 }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPage(pagination.currentPage - 1)"
                        >Trước</a
                      >
                    </li>
                    <li
                      class="page-item"
                      v-for="page in pagination.totalPages"
                      :key="page"
                      :class="{ active: pagination.currentPage === page - 1 }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPage(page - 1)"
                        >{{ page }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled:
                          pagination.currentPage === pagination.totalPages - 1,
                      }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPage(pagination.currentPage + 1)"
                        >Sau</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, nextTick, computed } from "vue";
import { useToast } from "vue-toastification";
import dashboardService from "@/services/taskDashboardService";
import workspaceService from "@/services/workspaceService";
import userService from "@/services/userService";
import workColumnService from "@/services/workColumnService";
import phongBanService from "@/services/phongBanService";
import { useRoute } from "vue-router";

const toast = useToast();
const route = useRoute();
const loading = ref(true);
const error = ref(null);
const dashboardData = ref(null);
const stackedWorkspaceData = ref([]);
const detailedTasks = ref([]);
const pagination = reactive({
  currentPage: 0,
  totalPages: 0,
  totalElements: 0,
  pageSize: 10,
});

const workspaces = ref([]);
const users = ref([]);
const columns = ref([]);
const selectedUser = ref(null);
const listTaskRef = ref(null);
const phongBanOptions = ref([]); // State mới
const selectedPhongBan = ref(null);

const initialFilters = {
  workspaceId: null,
  columnId: null,
  assignedUserId: null,
  trangThaiCongViec: null,
  doUuTien: null,
  isOverdue: null,
  phongBanId: null,
  doKho: null,
};
const filters = reactive({ ...initialFilters });

const timePreset = ref("nam");
const customStartDate = ref("");
const customEndDate = ref("");

// --- MAPS for Display ---
const priorityMap = {
  URGENT: "Khẩn cấp",
  HIGH: "Cao",
  MEDIUM: "Trung bình",
  LOW: "Thấp",
};

const statusMap = {
  TODO: "Cần làm",
  IN_PROGRESS: "Đang làm",
  DONE: "Hoàn thành",
  ARCHIVED: "Lưu trữ",
};

// --- COMPUTED PROPERTIES ---
const kpiCards = computed(() => {
  const stats = dashboardData.value?.theThongKeChinh;
  if (!stats) return [];
  return [
    {
      label: "Tổng Công Việc",
      value: stats.tongSoCongViec,
      icon: "fa fa-tasks",
      cardClass: "kpi-card-total",
      iconColor: "icon-total",
    },
    {
      label: "Đang Thực Hiện",
      value: stats.congViecDangThucHien,
      icon: "fa fa-spinner",
      cardClass: "kpi-card-progress",
      iconColor: "icon-progress",
    },
    {
      label: "Bị Quá Hạn",
      value: stats.congViecQuaHan,
      icon: "fa fa-exclamation-triangle",
      cardClass: "kpi-card-overdue",
      iconColor: "icon-overdue",
    },
    {
      label: "Đã Hoàn Thành",
      value: stats.congViecHoanThanh,
      icon: "fa fa-check-square-o",
      cardClass: "kpi-card-done",
      iconColor: "icon-done",
    },
  ];
});

// --- WATCHERS ---
watch(selectedUser, (newUser) => {
  filters.assignedUserId = newUser ? newUser.idNguoiDung : null;
});
watch(selectedPhongBan, (newPhongBan) => {
  const pbId = newPhongBan ? newPhongBan.idPhongBan : null;
  filters.phongBanId = pbId;
  // Gọi lại fetchFilterData với ID phòng ban để lọc users
  fetchFilterData(pbId);
});
watch(
  () => filters.workspaceId,
  (newWsId) => {
    filters.columnId = null;
    columns.value = [];
    if (newWsId) fetchColumnsForWorkspace(newWsId);
  }
);

watch([customStartDate, customEndDate], ([start, end]) => {
  if (start && end) timePreset.value = null;
});

// Hàm tải options phòng ban
const loadPhongBanOptions = async () => {
  try {
    const response = await phongBanService.getActiveOptions();
    if (response.data.data) {
      phongBanOptions.value = response.data.data;
    }
  } catch (error) {
    console.error("Lỗi khi tải danh sách phòng ban:", error);
    // toast.error("Không thể tải danh sách phòng ban."); // Bạn có thể bỏ comment nếu muốn hiện toast
  }
};
// --- METHODS ---
const setTimePreset = (preset) => {
  timePreset.value = preset;
  customStartDate.value = "";
  customEndDate.value = "";
};

const resetFilters = () => {
  filterNull();
  executeFilters();
};

const filterNull = () => {
  Object.assign(filters, initialFilters);
  selectedUser.value = null;
  selectedPhongBan.value = null;
  customStartDate.value = "";
  customEndDate.value = "";
  timePreset.value = "nam";
  fetchFilterData();
};

const toLocalISOString = (date) => {
  if (!date) return "";

  const pad = (num) => num.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const buildFilterParams = () => {
  // ... (Không thay đổi, giữ nguyên logic của bạn)
  const params = {
    workspaceId: filters.workspaceId,
    columnId: filters.columnId,
    assignedUserId: filters.assignedUserId,
    trangThaiCongViec: filters.trangThaiCongViec,
    doUuTien: filters.doUuTien,
    isOverdue: filters.isOverdue,
    phongBanId: filters.phongBanId,
    doKho: filters.doKho,
  };
  if (customStartDate.value && customEndDate.value) {
    const start = new Date(customStartDate.value);
    start.setHours(0, 0, 0, 0); // Đảm bảo bắt đầu từ đầu ngày

    const end = new Date(customEndDate.value);
    end.setHours(23, 59, 59, 999); // Đảm bảo kết thúc vào cuối ngày

    params.startDate = toLocalISOString(start);
    params.endDate = toLocalISOString(end);
  } else {
    const now = new Date();
    let start = new Date(now);
    let end = new Date(now);
    if (timePreset.value === "ngay") {
      start = new Date(now);
      end = new Date(now);
    } else if (timePreset.value === "tuan") {
      const dayOfWeek = now.getDay();
      // Logic để lấy ngày thứ Hai của tuần hiện tại
      const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      start.setDate(diff);

      end = new Date(start);
      end.setDate(start.getDate() + 6); // Thứ Hai + 6 ngày = Chủ nhật
    } else if (timePreset.value === "nam") {
      start = new Date(now.getFullYear(), 0, 1);
      end = new Date(now.getFullYear(), 11, 31);
    } else {
      // 'thang'
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    }
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    params.startDate = toLocalISOString(start);
    params.endDate = toLocalISOString(end);
  }
  return params;
};

// --- Badge and Style Methods ---
const getPriorityBadgeClass = (priority) => {
  switch (priority) {
    case "URGENT":
      return "bg-inverse-danger";
    case "HIGH":
      return "bg-inverse-warning";
    case "MEDIUM":
      return "bg-inverse-info";
    case "LOW":
      return "bg-inverse-success";
    default:
      return "bg-inverse-light";
  }
};

const getStatusBadgeClass = (status) => {
  switch (status) {
    case "TODO":
      return "badge-info";
    case "IN_PROGRESS":
      return "badge-warning";
    case "DONE":
      return "badge-success";
    case "ARCHIVED":
      return "badge-secondary";
    default:
      return "badge-light";
  }
};

const isOverdue = (dueDate, status) => {
  if (!dueDate || status === "DONE" || status === "ARCHIVED") {
    return false;
  }
  return new Date(dueDate) < new Date();
};

// --- LOGIC VẼ BIỂU ĐỒ ---
// ... (Không thay đổi, giữ nguyên logic vẽ biểu đồ của bạn)
const destroyCharts = (ids) => {
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.innerHTML = "";
  });
};

const renderAllCharts = () => {
  if (typeof window.Morris === "undefined") {
    console.error("Morris.js library is not loaded.");
    return;
  }

  destroyCharts([
    "chart-trang-thai",
    "chart-do-uu-tien",
    "chart-xu-huong",
    "chart-stacked-workspace",
    "chart-do-kho",
  ]);

  if (dashboardData.value) {
    renderBarChart(dashboardData.value.phanBoCongViecTheoTrangThai);
    renderDonutChart(dashboardData.value.phanBoCongViecTheoDoUuTien);
    renderLineChart(dashboardData.value.xuHuongCongViec);
    renderDonutChartDifficulty(dashboardData.value.phanBoCongViecTheoDoKho);
  }
  if (stackedWorkspaceData.value) {
    renderStackedBarChart(stackedWorkspaceData.value);
  }
};

const renderBarChart = (data) => {
  const chartElement = document.getElementById("chart-trang-thai");
  if (!chartElement) return;
  const chartData =
    data && data.length > 0
      ? data.map((item) => ({
          y: statusMap[item.ten] || item.ten,
          a: item.soLuong,
        }))
      : [];
  window.Morris.Bar({
    element: chartElement,
    data: chartData,
    xkey: "y",
    ykeys: ["a"],
    labels: ["Số lượng"],
    barColors: ["#007bff"],
    resize: true,
  });
};

const renderDonutChart = (data) => {
  const chartElement = document.getElementById("chart-do-uu-tien");
  if (!chartElement) return;
  const donutData =
    data && data.length > 0
      ? data.map((item) => ({
          label: priorityMap[item.ten] || item.ten,
          value: item.soLuong,
        }))
      : [];
  window.Morris.Donut({
    element: chartElement,
    data: donutData,
    colors: ["#dc3545", "#ffc107", "#17a2b8", "#28a745"],
    resize: true,
  });
};

const renderDonutChartDifficulty = (data) => {
  const chartElement = document.getElementById("chart-do-kho");
  if (!chartElement) return;

  const formatLabel = (label) => {
    const labels = {
      EASY: "Dễ",
      MEDIUM: "Vừa",
      HARD: "Khó",
      UNSPECIFIED: "Chưa xác định",
    };
    return labels[label] || label;
  };

  const donutData =
    data && data.length > 0
      ? data.map((item) => ({
          label: formatLabel(item.ten),
          value: item.soLuong,
        }))
      : [];

  window.Morris.Donut({
    element: chartElement,
    data: donutData,
    colors: ["#28a745", "#ffc107", "#dc3545", "#6c757d"], // Xanh, Vàng, Đỏ, Xám
    resize: true,
  });
};

const renderLineChart = (data) => {
  const chartElement = document.getElementById("chart-xu-huong");
  if (!chartElement) return;
  const lineData =
    data && data.length > 0
      ? data.map((item) => ({ y: item.thoiGian, a: item.soLuong }))
      : [];
  window.Morris.Line({
    element: chartElement,
    data: lineData,
    xkey: "y",
    ykeys: ["a"],
    labels: ["Việc hoàn thành"],
    lineColors: ["#28a745"],
    parseTime: false,
    resize: true,
  });
};

const renderStackedBarChart = (data) => {
  const chartElement = document.getElementById("chart-stacked-workspace");
  if (!chartElement) return;
  if (!data || data.length === 0) {
    chartElement.innerHTML =
      '<div class="text-center text-muted p-5">Không có dữ liệu.</div>';
    return;
  }
  const morrisData = data.map((item) => ({
    y: item.tenNhom,
    ...item.giaTriTheoLoai,
  }));
  const ykeys = [
    ...new Set(
      data.flatMap((item) =>
        item.giaTriTheoLoai ? Object.keys(item.giaTriTheoLoai) : []
      )
    ),
  ].sort();
  if (ykeys.length === 0) return;

  const barColors = ykeys.map((key) => {
    if (key === "TODO") return "#ffc107";
    if (key === "IN_PROGRESS") return "#007bff";
    if (key === "DONE") return "#28a745";
    return "#6c757d";
  });
  window.Morris.Bar({
    element: chartElement,
    data: morrisData,
    xkey: "y",
    ykeys: ykeys,
    labels: ykeys.map((key) => statusMap[key] || key),
    stacked: true,
    resize: true,
    barColors: barColors,
  });
};

// --- CÁC HÀM GỌI API ---
// ... (Không thay đổi, giữ nguyên logic gọi API của bạn)
const executeFilters = async () => {
  loading.value = true;
  error.value = null;
  pagination.currentPage = 0;
  const params = buildFilterParams();

  try {
    const [coreDataRes, stackedDataRes, tasksRes] = await Promise.all([
      dashboardService.getData(params),
      dashboardService.getWorkspaceStackedChart(params),
      fetchDetailedTasks(params),
    ]);

    dashboardData.value = coreDataRes.data;
    stackedWorkspaceData.value = stackedDataRes.data;
  } catch (err) {
    toast.error("Lỗi khi tải dữ liệu dashboard.");
    console.error(err);
    error.value = "Không thể tải dữ liệu. Vui lòng thử lại.";
  } finally {
    loading.value = false;
    nextTick(() => {
      renderAllCharts();
    });
  }
};

const fetchFilterData = async (phongBanId = null) => {
  try {
    const userParams = {};
    if (phongBanId) {
      userParams.phongBanId = phongBanId;
    }

    const [wsRes, userRes] = await Promise.all([
      workspaceService.getAll(),
      userService.getAll(userParams),
    ]);
    workspaces.value = wsRes.data;
    users.value = userRes.data;

    if (
      selectedUser.value &&
      !users.value.some((u) => u.idNguoiDung === selectedUser.value.idNguoiDung)
    ) {
      selectedUser.value = null;
      filters.assignedUserId = null;
    }
  } catch (err) {
    toast.error("Không thể tải dữ liệu cho bộ lọc.");
  }
};

const fetchColumnsForWorkspace = async (wsId) => {
  try {
    const res = await workColumnService.getAllByWorkspaceId(wsId);
    columns.value = res.data;
  } catch {
    toast.error("Không thể tải danh sách cột.");
  }
};

const fetchDetailedTasks = async (params) => {
  try {
    const queryParams = {
      ...params,
      page: pagination.currentPage,
      size: pagination.pageSize,
      sort: "ngayTao,desc",
    };
    const res = await dashboardService.getDetailedTasks(queryParams);
    detailedTasks.value = res.data.content;
    pagination.totalPages = res.data.totalPages;
    pagination.totalElements = res.data.totalElements;
  } catch (e) {
    console.error("Lỗi khi tải danh sách công việc chi tiết:", e);
    toast.error("Lỗi khi tải danh sách công việc chi tiết.");
  }
};

const goToPage = (page) => {
  if (page >= 0 && page < pagination.totalPages) {
    pagination.currentPage = page;
    fetchDetailedTasks(buildFilterParams());
  }
};

const isCompletedLate = (completionDate, dueDate) => {
  // Nếu không có ngày hoàn thành hoặc ngày hết hạn, không thể so sánh
  if (!completionDate || !dueDate) {
    return false;
  }

  // So sánh hai ngày sau khi đã chuyển thành đối tượng Date
  return new Date(completionDate) > new Date(dueDate);
};

// --- LIFECYCLE ---
// Trong <script setup>

onMounted(async () => {
  // 1. Tải dữ liệu cho các dropdown lọc (luôn cần)
  loadPhongBanOptions();
  await fetchFilterData();

  // 2. Xác định các tham số từ URL
  const dailyTask = route.query.daily;
  const overdueTask = route.query.overdue;
  const userId = route.query.userid;
  let shouldScroll = false;

  // 3. Thiết lập bộ lọc (CHƯA GỌI API)
  if (dailyTask) {
    setTimePreset("ngay"); // Đặt bộ lọc thời gian
    shouldScroll = true;
  } else if (overdueTask) {
    // ✅ Dùng 'else if' để tránh gọi 2 lần
    filters.isOverdue = true;
    shouldScroll = true;
  } // 4. Gọi API LỌC MỘT LẦN DUY NHẤT
  // Nếu không có param nào, bộ lọc sẽ dùng giá trị mặc định (timePreset="thang")

  if (userId) {
    filters.assignedUserId = userId;
  }
  await executeFilters();

  // 5. Bây giờ, chờ Vue render xong dữ liệu
  await nextTick();

  // 6. Cuộn xuống nếu cần
  if (shouldScroll) {
    if (listTaskRef.value) {
      // Đảm bảo ref tồn tại
      listTaskRef.value.scrollIntoView({ behavior: "smooth" });
    }
  }
});

watch(
  [
    () => route.query.daily,
    () => route.query.overdue,
    () => route.query.userid,
  ],

  async ([newDaily, newOverdue, newUserId]) => {
    filterNull();
    if (newDaily) {
      setTimePreset("ngay");
    } else if (newOverdue) {
      filters.isOverdue = true;
    }
    if (newUserId) {
      filters.assignedUserId = newUserId;
    }
    await executeFilters();
    await nextTick(() => {
      if (listTaskRef.value) {
        // Đảm bảo ref tồn tại
        listTaskRef.value.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
);
</script>

<style scoped>
/* avatar */
.avatar > img {
  height: 100%;
}
/* General Card Style */
.card {
  box-shadow: 0 0 1.25rem rgba(31, 45, 61, 0.08);
  border: none;
  border-radius: 8px;
  margin-bottom: 24px;
}

/* Filter Card Styles */
.filter-card-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-card-header .collapse-icon {
  transition: transform 0.3s ease;
}
.filter-card-header[aria-expanded="false"] .collapse-icon {
  transform: rotate(-90deg);
}
.filter-card .form-group {
  margin-bottom: 1rem; /* Consistent spacing */
}
label {
  font-weight: 500;
}

/* Button Styles */
.btn-group .btn.active {
  background-color: #007bff;
  color: white;
}
.btn {
  border-radius: 5px;
}

/* KPI Card Styles */
.dash-widget {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.dash-widget:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
.dash-widget-icon {
  border-radius: 8px;
  color: #fff;
}
/* KPI Colors */
.kpi-card-total {
  background-color: #e7f3ff;
}
.icon-total {
  background-color: #007bff;
}

.kpi-card-progress {
  background-color: #fff8e1;
}
.icon-progress {
  background-color: #ffc107;
}

.kpi-card-overdue {
  background-color: #ffe8e8;
}
.icon-overdue {
  background-color: #dc3545;
}

.kpi-card-done {
  background-color: #e9f9ee;
}
.icon-done {
  background-color: #28a745;
}

/* Chart Styles */
#chart-trang-thai,
#chart-do-uu-tien,
#chart-xu-huong,
#chart-stacked-workspace,
#chart-do-kho {
  height: 320px;
}

/* Badge Styles */
.badge {
  font-size: 0.75rem;
  padding: 0.4em 0.7em;
  font-weight: 500;
}
.badge-danger {
  background-color: #dc3545;
  color: #fff;
}
.badge-warning {
  background-color: #ffc107;
  color: #212529;
}
.badge-primary {
  background-color: #007bff;
  color: #fff;
}
.badge-secondary {
  background-color: #6c757d;
  color: #fff;
}
.badge-success {
  background-color: #28a745;
  color: #fff;
}
.badge-info {
  background-color: #17a2b8;
  color: #fff;
}

.task-title-col {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Giới hạn tối đa 2 dòng */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; /* Hiện dấu ... */
  word-break: break-word; /* Ngắt từ nếu từ quá dài */
  line-height: 1.4; /* Khoảng cách dòng */
  max-width: 100%; /* Đảm bảo không tràn */
  font-weight: 600; /* In đậm nhẹ cho dễ đọc */
  margin-bottom: 4px;
}

/* Đảm bảo cột tiêu đề có độ rộng tối thiểu để không bị bóp quá bé */
.table th:first-child,
.table td:first-child {
  min-width: 250px;
  max-width: 400px; /* Giới hạn chiều rộng tối đa */
}
</style>
